import {DocSharingMessage} from '../../shared/doc-sharing-message';

export class MultipleFileUploadDialogParams {
    matterId: number;
    message: DocSharingMessage;
    readOnly: boolean;
}
